import { Card, CircularProgress, Container, Grid } from '@mui/joy'
import React, { useEffect, useState } from 'react'
import Stamps from './Stamps'
import FileUpload from '../components/FileUpload'
import EditableTypography from '../components/EditableTypography'
import {
  useGetStoreDataQuery,
  useUploadBackgroundImageMutation,
  useUploadStoreLogoMutation,
} from '../services/branding'

function PunchCard() {
  const [backgroundColor, setBackgroundColor] = useState<string>('')
  const [textColor, setTextColor] = useState('#000000')
  const [font, setFont] = useState('')
  const [backgroundImageUrl, setBackgroundImageUrl] = useState('')
  const [cardBackGround, setCardBackGround] = useState<string | null>(null)
  const [storeLogoFile] = useState<File | null>(null)

  const [uploadStoreLogo, { isLoading: isUploadStoreLogoLoading }] =
    useUploadStoreLogoMutation({ fixedCacheKey: 'shared-delete-reward' })
  const { data: storeData, isLoading: isStoreDataLoading } =
    useGetStoreDataQuery()
  const [, { isLoading: isUploadBackgroundImageLoading }] =
    useUploadBackgroundImageMutation({ fixedCacheKey: 'shared-delete-reward' })

  useEffect(() => {
    if (storeData) {
      setCardBackGround(storeData.backgroundImageUrl ?? '')
      setBackgroundImageUrl(storeData.logoUrl ?? null)
      setTextColor(storeData.textColor)
      setFont(storeData.font)
      setBackgroundColor(storeData.backgroundColor ?? '')
    }
  }, [storeData])

  useEffect(() => {
    if (storeLogoFile !== null) {
      const formData = new FormData()
      formData.append('file', storeLogoFile)
      uploadStoreLogo(formData)
    }
  }, [storeLogoFile, uploadStoreLogo])

  const handleUploadSuccess = () => {
    console.log('Upload successful')
  }

  const handleUploadError = (error: unknown) => {
    console.error('Upload failed', error)
  }

  return (
    <Container sx={{ width: 300, mt: -2 }}>
      <Grid container>
        <Grid
          container
          xs={12}
          sm={12}
          md={12}
          justifyContent="center"
          alignItems="center"
        >
          <Card
            size="md"
            variant="outlined"
            sx={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
              flexDirection: 'column',
              pb: 8,
              ...(backgroundColor !== '' &&
                cardBackGround === '' && {
                  backgroundColor: { backgroundColor },
                }),
              ...(backgroundColor === '' &&
                cardBackGround !== '' && {
                  backgroundImage: `url(${cardBackGround}?timestamp=${Date.now()})`,
                }),
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            {cardBackGround !== '' && !backgroundColor && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(255, 255, 255, 0.6)',
                  zIndex: 0,
                }}
              ></div>
            )}

            <FileUpload
              backgroundImageUrl={backgroundImageUrl}
              setBackgroundImageUrl={setBackgroundImageUrl}
              onUploadSuccess={handleUploadSuccess}
              onUploadError={handleUploadError}
              isUploadBackgroundImageLoading={isUploadStoreLogoLoading}
            />
            {isUploadBackgroundImageLoading ||
            isUploadStoreLogoLoading ||
            isStoreDataLoading ||
            isUploadStoreLogoLoading ? (
              <CircularProgress size="lg" />
            ) : (
              <EditableTypography
                props={{
                  level: 'body-md',
                  component: 'p',
                  fontWeight: 'md',
                  zIndex: 1,
                }}
                font={font}
                backgroundColor={backgroundColor}
                textColor={textColor}
                sx={{
                  textAlign: 'center',
                  wordWrap: 'break-word',
                  whiteSpace: 'normal',
                }}
                initialText={storeData?.text ?? ''}
              />
            )}
            <Stamps />
          </Card>
        </Grid>
      </Grid>
    </Container>
  )
}

export default PunchCard
